module.exports = __webpack_public_path__ + "img/btn_wallpaper2_txt.a2ab9c63.png";